import { render } from "./TabBarPage.vue?vue&type=template&id=02999ff8"
import script from "./TabBarPage.vue?vue&type=script&lang=js"
export * from "./TabBarPage.vue?vue&type=script&lang=js"

import "./TabBarPage.vue?vue&type=style&index=0&id=02999ff8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__